import React from "react";

import "./hero.css";

const Hero = () => {
  return (
    <>
      <section className="hero">
        <div className="container">
          <h1
            style={{
              color: "#ffffff",
              fontWeight: "700",
              fontfamily: "Poppins",
              textShadow: "1px 4px 12px #0d0d0a;",
            }}
          >
            Emaad Abdullah Al Fakhri Trainding Contracting & IT Services
            <span style={{ color: "#ffffff" }}></span> <br />
          </h1>
          <div style={{ display: "flex" }}>
            <h4 class="callbutton">
              <span class="fa fa-envelope"></span> &nbsp;Contact Us
            </h4>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
